import Head from "next/head";

export const Metadata = ({ post, mainContent }) => {

  return (
    <Head>
      {/* <!-- Primary Meta Tags --> */}
      <title>{`${post?.title} | Verzel`}</title>
      <meta name="title" content={`${post?.title} | Verzel`} />
      <meta name="description" content={mainContent} />

      {/* <!-- Open Graph / Facebook --> */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={`https://verzel.com.br/landings/${post?.slug}.html`} />
      <meta property="og:title" content={`${post?.title} | Verzel`} />
      <meta property="og:description" content={mainContent} />
      <meta property="og:image" content="https://i.ibb.co/Rb6NNjT/verzel-logo-meta.png" />

      {/* <!-- Twitter --> */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={`https://verzel.com.br/landings/${post?.slug}.html`} />
      <meta property="twitter:title" content={`${post?.title} | Verzel`} />
      <meta property="twitter:description" content={mainContent} />
      <meta property="twitter:image" content="https://i.ibb.co/Rb6NNjT/verzel-logo-meta.png" />
    </Head>
  );
};
